import { render } from "./TextBlock.vue?vue&type=template&id=1e7d7d22"
import script from "./TextBlock.vue?vue&type=script&lang=js"
export * from "./TextBlock.vue?vue&type=script&lang=js"

import "./TextBlock.vue?vue&type=style&index=0&id=1e7d7d22&lang=css"

import exportComponent from "/Users/marco/Documents/VueJS/marco-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__